import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { getQueryString } from '../../utils/filters-util';
import { decrementPaginationCount, incrementPaginationCount } from '../../utils/pagination-util';
import { fetchTemplateListApi } from '../../api/templates-api';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  templates: [],
  senderEmails: [],
  senderPhones: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchTemplatesListing = createAsyncThunk(
  'templates/listing',
  async (updatedParamsObject = {}, { dispatch }) => {
    try {
      const paramsObj = {
        'q[s]': 'created_at desc',
        ...updatedParamsObject,
      };
      const res = await fetchTemplateListApi({}, getQueryString(paramsObj));
      if (res?.status) {
        dispatch(setQuickLinks(res?.user_filters));
      }
      return res;
    } catch (error) {
      toast.error(getErrorString(error));
    }
  },
);

const TemplatesSlice = createSlice({
  name: 'templates',
  initialState,
  reducers: {
    setTemplatesActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
    addUpdateTemplate: (state, action) => {
      const newTemplate = action.payload;
      const existingTemplate = state.templates.find((item) => item.id === newTemplate?.id);

      if (existingTemplate) {
        Object.assign(existingTemplate, newTemplate);
      } else {
        state.templates.unshift(newTemplate);
        incrementPaginationCount(state.pagination);
      }
    },
    deleteTemplate: (state, action) => {
      const index = state.templates.findIndex((item) => item.id === action.payload);
      if (index !== -1) {
        state.templates.splice(index, 1);
        decrementPaginationCount(state.pagination);
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchTemplatesListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchTemplatesListing.fulfilled, (state, action) => {
        if (state.loading) {
          //means first time loading
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.templates = action?.payload?.data || [];
        state.senderEmails = action?.payload?.senders?.email_template_senders || [];
        state.senderPhones = action?.payload?.senders?.text_template_senders || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchTemplatesListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setTemplatesActiveColumn, addUpdateTemplate, deleteTemplate } = TemplatesSlice.actions;
export default TemplatesSlice.reducer;
